import { LockOutlined } from '@mui/icons-material'
import { Box, Typography } from '@mui/material'

const AccessRestrictedMessage = () => (
  <Box
    sx={{
      textAlign: 'center',
      padding: 4,
    }}
  >
    <LockOutlined sx={{ fontSize: 48, color: 'text.secondary', mb: 2 }} />
    <Typography variant="h5" component="h1" sx={{ mb: 1, color: 'error.main' }}>
      Access Restricted
    </Typography>
    <Typography variant="body1" color="text.secondary">
      It looks like you don't have permission to view this content.
    </Typography>
    <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
      If you believe you should have access, please contact your administrator.
    </Typography>
  </Box>
)

export default AccessRestrictedMessage